import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { TransactionService } from '../../../titleregistration/services/transaction.service';

export class ViewTransactionData {
    constructor(public businessTransactionNumberId: number) {}
}

@Component({
    selector: 'view-transaction-modal',
    templateUrl: './view-transaction-modal.html',
})

export class ViewTransactionWindow extends BaseComponent {
    public businessTransactionNumberId: number;
    public WipJson = '';

    constructor(
        public dialogRef: MatDialogRef<ViewTransactionWindow>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: ViewTransactionData,
        private transactionService: TransactionService
    ) {
        super();
    }

    ngOnInit() {
        this.businessTransactionNumberId = this.data.businessTransactionNumberId;
        this.transactionService.getTransaction(this.businessTransactionNumberId).subscribe(
            wipObject => this.WipJson = JSON.stringify(wipObject),
            err => this.handleValidationResult(err));
    }

    public cancel() {
        this.dialogRef.close();
    }
}
